import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval } from 'rxjs';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard',
  template: `
  <app-m-dashboard [tabSet]="tabSet" *ngIf="env.isMobile"></app-m-dashboard>
  <app-d-dashboard *ngIf="!env.isMobile"></app-d-dashboard>
  `,
  styles: []
})
export class DashboardComponent extends BaseClass<any> implements OnInit {
  public data: any;
  public casinoData: any;
  public inPlayData: any;
  public listRes: any;
  public marketsReq: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public oddsLisDisNew: any = {};
  public exposLisDis: any = {};
  public newOddsEnable: boolean = false;
  public marketData: any;
  public tabId: any = 'in_play';
  public tabSet: any;
  public viewBy: any = 't';
  public _pusher!: PusherService

  constructor(
    public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public actRoute: ActivatedRoute,
    public router: Router,
    protected injector: Injector,
  ) {
    super(document);
  }

  constructorCallData() {
    if (this.isLogin()) {
      this._pusher = this.injector.get<PusherService>(PusherService);
      const sub1 = this._pusher.eventListUpdate().subscribe(res => {
        if (res?.op == 'UPDATE') {
          this.getData();
        }
      });
      this.subs.push(sub1);
    }

    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.webSocketUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.marketData);
        } else {
          this.getOdds(this.marketsReq);
        }
      }
    });
    this.subs.push(sub2);

    const sub3 = this._shared.sharedTabSet.subscribe((rp: any) => {
      if (rp) {
        this.tabSet = rp;
      }
    });
    this.subs.push(sub3);
  }

  ngOnInit(): void {
    this.getUserData();
  }


  getServices(): IbaseService<any> {
    return this.service;
  }

  getUserData() {
    if (this.isLogin()) {
      this.userData = this.getLocalItem('user');
      this.webSocketUrl = this.getLocalItem('ws', false);
      if (this.webSocketUrl) {
        this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
          (res) => {
            if (res) {
              this.userData.balance = res.balance;
              this.userData.pl = res.pl;
              this.userData.available_balance = parseFloat(res.pl) + parseFloat(res.balance) + parseFloat(res.expose);
              this.userData.expose = res.expose;
              this.setLocalItem('user', this.userData);
              this.userData = this.getLocalItem('user');
            }
          },
          (err) => {
            console.log(err);
          });
      }
    }
  }

  getData() {
    this.isLoad = true;
    this.data = undefined;
    this.inPlayData = undefined;

    this.getServices().Get(`${this.env.baseUrl + (this.isLogin() ? this.api.eventListNew : this.api.eventListNewG)}`).subscribe(
      (res: ResFormat) => {
        if (res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.listRes = res.data;
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
          this.setRaceSideMenu(7, res.data.races);
          this.setRaceSideMenu(4339, res.data.races);
          res.data.races.forEach((element: any) => {
            element['in_play'] = 1;
          });
          let events = [...res.data.events, ...res.data.races];
          this.commonLogics(res, events);

          // if (this.isLogin())

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setRaceSideMenu(id: any, items: any) {
    let dt = items.filter((s: any) => { return Number(s.event_type_id) == Number(id) });
    this.setLocalItem(`sideRaceMenu${id}`, dt);
    this._shared.emitSideMenu(dt);
  }

  getCasinoData() {
    this.getServices().Get(`${this.env.baseUrl + (this.isLogin() ? this.api.casino1 : this.api.casino1G)}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.casinoData = res.data;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getRaceListData(id: any) {
    this.isLoad = true;
    this.data = undefined;
    this.inPlayData = undefined;

    this.getServices().Get(`${this.env.baseUrl + (this.isLogin() ? this.api.raceList : this.api.raceListG)}/${id}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.setLocalItem(`sideRaceMenu${id}`, res?.data?.race);
          this._shared.emitSideMenu(res?.data?.race);
          res.data.race.forEach((element: any) => {
            element['in_play'] = 1;
            element['event_type_id'] = Number(id);
          });
          this.commonLogics(res, res?.data?.race);

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  commonLogics(res: any, events: any) {
    this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
    this.setLocalItem('ws', this.webSocketUrl, false);
    events = this.UTC_to_Local_timeZone(events);
    this.marketsReq = this.genMarketReq(events);

    this.marketData = res?.data;
    this.data = events;
    this.inPlayData = this.getInplayData(events);
    this.isLoad = false;

    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
      this.newOddsEnable = true;
      this.getOddsNew(this.marketsReq, res?.data);
    } else {
      this.newOddsEnable = false;
      this.getOdds(this.marketsReq);
    }
    // this.getExposure(this.marketsReq);

  }

  getOdds(req: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
      (res) => {
        res = this.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getOddsNew(req: any, resData: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getExposure(req: any) {
    this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          res = res.data.exposes;
          // res = this.string_to_JSON(res);

          res.forEach((element: any) => {
            this.exposLisDis[element?.marketId ? element?.marketId : element?.market_id] = element;
          });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  genMarketReq(res: any) {
    let market: any[] = [];
    res.forEach((element: any) => {
      market.push('market_ids[]=' + encodeURIComponent(element.market_id));
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];

    return market.join('&') as any;
  }

  onSelect(data: any): void {
    // this.data = undefined;
    this.tabId = data.id;
    if (this.events.races.includes(data.id)) {
      // this.isLoad = true;
      // this.getRaceListData(data.id);
    } else if (!this.events.casino.includes(data.id)) {
      // this.getData();
    }
  }

  getInplayData(data: any) {
    const groupedInPlay = this.groupBy(data, (dat: any) => dat.in_play);
    const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);

    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]

    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });

    const groupedCat = this.groupBy(uniqueArray, (dat: any) => dat.event_type_id);
    var cricketEvents = groupedCat.get(4) ? groupedCat.get(4) : [];
    var otherEvents = uniqueArray.filter((e: any) => { return (e.event_type_id != 4) })
    const inplay = [...cricketEvents, ...otherEvents];

    return inplay;
  }

  redirectCasino(mn_id: any) {
    if (this.isLogin()) {
      this.router.navigate([`${this.env.isMobile ? '/m/casino' : '/casino'}`, mn_id.split(':')[0]], { queryParams: { name: mn_id.split(':')[1] } });
    } else {
      this._common.openLogin();
    }
  }
  redirectCasinoDetail(id: any, game_id :any) {
    if (this.isLogin()) {
      let multiplier = 100;
      let msg = `Profit & amp; Loss in iCasino would be ${multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${multiplier}. <br> Please note(1 Point = ${multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${multiplier} अंक)`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate([`${this.env.isMobile ? '/m/casino-detail' : '/casino-detail'}`, id, game_id]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
    } else {
      this._common.openLogin();
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    // if (this.isLogin())
    //   this._pusher.unsubscribeChannel('event-list');
  }
}
